import React from "react"

export default function LineLayer(props) {
  const { data, getXValue, getYValue, colour, strokeWidth = 3, strokeModifier } = props

  const pathData = data
    .map((obs, index) => `${index === 0 ? "M" : "L"}${getXValue(obs)},${getYValue(obs)}`)
    .join(" ")

  return (
    <path
      d={pathData}
      fill="none"
      stroke={colour}
      strokeDasharray={strokeModifier === "dashed" ? 4 : 0}
      strokeWidth={strokeModifier === "dashed" ? 1 : strokeWidth}
    />
  )
}
